import { useEffect, useRef, useState } from 'react'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useRevalidateModules } from '@systemeio/util'
import { useRouter } from 'shared/hooks/use-router'

export function useOpenNotificationMenuQuery({ allowCheck }: { allowCheck: boolean }) {
  const { query, replaceQuery } = useRouter()
  const { revalidateModules } = useRevalidateModules()
  const isUsedOnce = useRef(false)
  const [openThroughQuery, setOpenThroughQuery] = useState(false)

  useEffect(() => {
    if (!allowCheck) return

    const { [useOpenNotificationMenuQuery.queryToOpenNotificationMenu]: targetedQuery, ...rest } =
      query

    if (targetedQuery === undefined) {
      isUsedOnce.current = false
      return
    }

    if (!isUsedOnce.current) {
      setOpenThroughQuery(true)
      revalidateModules([RequestModuleEnum.Notifications], true)
      replaceQuery(rest, { shallow: true })
      isUsedOnce.current = true
    }
  }, [allowCheck, query, replaceQuery, revalidateModules])

  return { openThroughQuery, setOpenThroughQuery }
}

useOpenNotificationMenuQuery.queryToOpenNotificationMenu = 'open-notification-center'
